import { netsparkAxios } from 'core/services/HTTPService';
// eslint-disable-next-line no-unused-vars
import { IScopeDescriptionForm, IScopeDescriptionParams } from 'pages/WirelineEngagements/WirelineEngagementsCreate/EngagementFormsWrapper/ScopeDescription/ScopeDescription.model';
import {
  IEngagement,
  IEngagementComment,
  IEngagementAttachment,
} from 'pages/WirelineEngagements/WirelineEngagements.models';
import {
  engagementsPath,
  getEngagementCommentsUrl,
  getEngagementEditCommentsUrl,
  getEngagementAttachmentsUrl,
  getEngagementEditAttachmentsUrl,
  getEngagementsScopeDescriptionUrl,
  getCreateEngagementsScopeDescriptionUrl,
} from 'core/api/constants';
// eslint-disable-next-line no-unused-vars
import { IDraftComment } from 'shared/widgets/Comments/Comments.models';
// eslint-disable-next-line no-unused-vars
import { IDraftAttachment } from 'shared/widgets/Attachments/Attachments.model';

export const getEngagements = () => netsparkAxios.get(engagementsPath);

export const getEngagementById = (id: string | number) => netsparkAxios.get<IEngagement>(`${engagementsPath}${id}/`);

export const createEngagement = (params) => netsparkAxios.post(`${engagementsPath}`, params);

export const updateEngagementById = (id, params) => netsparkAxios.put(`${engagementsPath}${id}/`, params);

export const getEngagementsScopeDescription = (
  { id, engagementId }: IScopeDescriptionParams,
) => {
  const path = getEngagementsScopeDescriptionUrl(id, engagementId);

  return netsparkAxios.get(path);
};

export const createEngagementsScopeDescription = (
  engagementId: string | number,
  params: IScopeDescriptionForm,
) => {
  const path = getCreateEngagementsScopeDescriptionUrl(engagementId);

  return netsparkAxios.post(path, params);
};

export const editEngagementsScopeDescription = (
  { id, engagementId }: IScopeDescriptionParams,
  params: IScopeDescriptionForm,
) => {
  const path = getEngagementsScopeDescriptionUrl(id, engagementId);

  return netsparkAxios.patch(path, params);
};

export const getEngagementComments = (signal: AbortSignal, engagementId: string | number) => (
  netsparkAxios.get<IEngagementComment[]>(getEngagementCommentsUrl(engagementId), { signal })
);

export const createEngagementComment = (
  engagementId: string | number,
  formData: IDraftComment,
) => (
  netsparkAxios.post<IEngagementComment>(getEngagementCommentsUrl(engagementId), formData)
);

export const editEngagementComment = (
  engagementId: string | number,
  commentId: string | number,
  formData: IDraftComment,
) => (
  netsparkAxios.put<IEngagementComment>(getEngagementEditCommentsUrl(
    engagementId, commentId), formData)
);

export const removeEngagementComment = (
  engagementId: string | number,
  commentId: string | number,
) => (
  netsparkAxios.delete(getEngagementEditCommentsUrl(engagementId, commentId))
);

export const getEngagementAttachments = (signal: AbortSignal, engagementId: string | number) => (
  netsparkAxios.get<IEngagementAttachment[]>(getEngagementAttachmentsUrl(engagementId), { signal })
);

export const createEngagementAttachment = (
  engagementId: string | number,
  attachmentFile: FormData,
) => (
  netsparkAxios.post(getEngagementAttachmentsUrl(engagementId), attachmentFile)
);

export const editEngagementAttachmentName = (
  engagementId: string | number,
  attachmentId: string | number,
  draftAttachment: IDraftAttachment,
) => (
  netsparkAxios.put<IEngagementAttachment>(getEngagementEditAttachmentsUrl(
    engagementId, attachmentId), draftAttachment)
);

export const removeEngagementAttachment = (
  engagementId: string | number,
  attachmentId: string | number,
) => (
  netsparkAxios.delete(getEngagementEditAttachmentsUrl(engagementId, attachmentId))
);
